module.exports = __webpack_public_path__ + "static/media/mysql-workbench.3ca9ea93.png";